import api from './api';

export interface User {
  _id: string;
  name: string;
  email: string;
  role: 'cliente' | 'admin';
  twoFactorEnabled: boolean;
  createdAt: string;
}

export interface CreateUserData {
  name: string;
  email: string;
  password: string;
  role?: 'cliente' | 'admin';
}

export interface UpdateUserData {
  name?: string;
  email?: string;
  role?: 'cliente' | 'admin';
}

export interface UsersResponse {
  success: boolean;
  count: number;
  data: User[];
}

export interface UserResponse {
  success: boolean;
  data: User;
}

export const userService = {
  // Obtener todos los usuarios (admin only)
  async getAllUsers(): Promise<UsersResponse> {
    const response = await api.get('/admin/users');
    return response.data;
  },

  // Obtener usuario por ID (admin only)
  async getUserById(id: string): Promise<UserResponse> {
    const response = await api.get(`/admin/users/${id}`);
    return response.data;
  },

  // Crear nuevo usuario (admin only)
  async createUser(userData: CreateUserData): Promise<UserResponse> {
    const response = await api.post('/admin/users', userData);
    return response.data;
  },

  // Actualizar usuario (admin only)
  async updateUser(id: string, userData: UpdateUserData): Promise<UserResponse> {
    const response = await api.put(`/admin/users/${id}`, userData);
    return response.data;
  },

  // Eliminar usuario (admin only)
  async deleteUser(id: string): Promise<void> {
    await api.delete(`/admin/users/${id}`);
  },

  // Cambiar contraseña de usuario (admin only)
  async changeUserPassword(id: string, newPassword: string): Promise<void> {
    await api.put(`/admin/users/${id}/password`, { newPassword });
  },

  // Solicitar reset de contraseña
  async forgotPassword(email: string): Promise<Record<string, unknown>> {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  // Restablecer contraseña
  async resetPassword(token: string, newPassword: string): Promise<void> {
    await api.post('/auth/reset-password', { token, newPassword });
  },
};